import { Toast, Tooltip } from './_bootstrap';

(function () {
	// * Tooltip initialization, remove it if not necessary
	document
		.querySelectorAll('[data-toggle="tooltip"]')
		.forEach((tooltipElement) => new Tooltip(tooltipElement));

	// * Toast initialization, remove it if not necessary
	document
		.querySelectorAll('.toast')
		.forEach((toastElement) => new Toast(toastElement));
})();

(function($) {
	$(document).ready(function() {

		$(window).scroll(function() {
			if ($(this).scrollTop() > 1){
				$('header').addClass("glide");
			}
			else{
				$('header').removeClass("glide");
			}
		});

		$('.field-objects-photos').photobox('a',{ time:0 });

		$('.fancy-form').fancybox();
		$('.fancy-img').fancybox();
		$('.fancy-map').fancybox();

		$('.view-review .views-field-body .field-content').readmore({
			speed: 75,
			collapsedHeight: 135,
			moreLink: '<a href="#" class="rm_button_more">Читать полностью</a>',
			lessLink: '<a href="#" class="rm_button_less">Скрыть</a>'
		});

		$('.node--type-objects .field-body-wrapper .field-body').readmore({
			speed: 75,
			collapsedHeight: 240,
			moreLink: '<a href="#" class="rm_button_more">Читать полностью</a>',
			lessLink: '<a href="#" class="rm_button_less">Скрыть</a>'
		});

		$.fn.textToggle = function(cls, str) {
			return this.each(function(i) {
				$(this).click(function() {
					var c = 0, el = $(cls).eq(i), arr = [str,el.text()];
					return function() {
						el.text(arr[c++ % arr.length]);
					}
				}());
			})
		};

		$(function(){
			$('.field-specialist-phone_button').textToggle(".field-specialist-phone_button","").click();
			$('.field-specialist-phone_button').textToggle(".field-specialist-phone_true","+7 (XXX) XXX-XX-XX").click();
		});

	});
})(jQuery);